import { useEffect } from 'react'

import { useAsyncError } from '@/modules/errors'
import { useFoldersStore } from '../stores'

export const useFolder = () => useFoldersStore((state) => state.folder)

export const useFolders = () => useFoldersStore((state) => state.folders)

export const useLoadingFolder = () =>
  useFoldersStore((state) => state.loadingFolder)

export const useLoadingFolders = () =>
  useFoldersStore((state) => state.loadingFolders)

export const useFoldersMutating = () =>
  useFoldersStore((state) => state.mutating)

export const useFoldersActions = () => useFoldersStore((state) => state.actions)

export const useFoldersMutations = () =>
  useFoldersStore((state) => state.mutations)

export const useFoldersLoaders = () => useFoldersStore((state) => state.loaders)

export const useFetchDocumentFolders = () => {
  const loaders = useFoldersLoaders()
  const throwError = useAsyncError()

  useEffect(() => {
    loaders.fetchFolders('document').catch(throwError)
  }, [loaders, throwError])
}
